module.exports = __webpack_public_path__ + "img/AMZN.f89efdd4.png";